function browserType() {
  if ((navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i)) || window?.__wxjs_environment === 'miniprogram') {
    return "miniprogram";
  } else {
    console.log("__wxjs_environment 不存在");
  }

  var system = {
    win: false,
    mac: false,
    x11: false,
    ipad: false,
  };
  //检测平台
  var p = navigator.platform;
  system.win = p.indexOf("Win") === 0;
  system.mac = p.indexOf("Mac") === 0;
  system.x11 = p === "X11" || p.indexOf("Linux") === 0;
  system.ipad = navigator.userAgent.match(/iPad/i) != null ? true : false;
  let stringPhoneReg = "\\b(ip(hone|od)|android|opera m(ob|in)i" + "|windows (phone|ce)|blackberry" + "|s(ymbian|eries60|amsung)|p(laybook|alm|rofile/midp|laystation portable)|nokia|fennec|htc[-_]" + "|mobile|up.browser|[1-4][0-9]{2}x[1-4][0-9]{2})\\b";

  var ua = navigator.userAgent.toLowerCase();

  if (ua.match(ua.match(/MicroMessenger/i) === 'micromessenger' || ua.match(/_SQ_/i) === '_sq_')) {
    return "weixin";
  } else if (ua.match(stringPhoneReg)) {
    return "mobile"
  } else if (system.win || system.mac || system.x11 || system.ipad) {
    return "pc";
  } else {
    return "pc";
  }
}



export default browserType;
